import { BrandManager } from './BrandManager'
import type { ProductBrand } from '../model'

export type BrandPickerValue = Pick<ProductBrand, 'id' | 'name'> | null

type BrandPickerProps = {
    value: BrandPickerValue
    onChange: (brand: ProductBrand | null) => void
    className?: string
}

export const BrandPicker = ({ value, onChange, className }: BrandPickerProps) => {
    return <BrandManager selectedBrandId={value?.id ?? null} onSelect={onChange} className={className} />
}
